import { Availability, Subcategory } from '@core/models';
import { SubcategoryFactory } from './subcategory.factory';
import { SubcategoryProcessingContext } from './interfaces';

export class SubcategoryProcessor {
	constructor(private readonly factory: SubcategoryFactory) {}

	processHome(
		subcategories: Subcategory[],
		availabilities: Availability[],
		now = new Date()
	): Subcategory[] {
		const initialContext: SubcategoryProcessingContext = {
			subcategories,
			availabilities,
			now,
		};

		return this.factory
			.createHomeRules()
			.reduce((context, rule) => rule(context), initialContext).subcategories;
	}
}

export const subcategoryProcessor = new SubcategoryProcessor(new SubcategoryFactory());
